module.exports = __webpack_public_path__ + "static/media/daize-logo.ac40251c.png";